// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import Editable from 'components/Editable/Editable'
import ActivitiesFilters from 'components/Activities/ActivitiesFilters'
import { get, loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'
import IconBack from 'components/svg/arrows/arrow-left.svg'

class PageHeader extends React.Component {
	constructor( props ) {
		super( props )

		let slidesCount = 0

		if ( props.slidesCount ) {
			slidesCount = props.slidesCount
		}

		this.state = {
			prevImage: null,
			prevTitle: null,
			prevTemplate: null,
			prevContentSection: null,
			imageLoaded: false,
			slidesCount: slidesCount,
			activeSlide: 1,
			slidesWidth: null,
			pageLinksIsOpen: false
		}
	}

	componentDidMount() {
		const { slidesCount } = this.props

		if ( slidesCount ) {
			this.setupSlider()
		}
	}

	componentWillUnmount() {
		clearInterval( this.interval )
	}

	componentWillReceiveProps( nextProps ) {
		const { page, overrideImage } = this.props
		const imageData = overrideImage ? overrideImage : page.featured_image
		const nextImageData = nextProps.overrideImage ? nextProps.overrideImage : nextProps.page.featured_image
		const nextTitle = nextProps.page ? nextProps.page.title : ''

		if ( ! imageData || ! imageData.url ) {
			return
		}

		if ( ! nextImageData || imageData.url != nextImageData.url ) {
			this.setState( {
				prevImage: imageData,
				imageLoaded: false
			} )

			setTimeout( () => {
				this.setState( {
					prevImage: null
				} )
			}, 1100 )
		}

		if ( ! nextTitle || page.title != nextTitle ) {
			this.setState( {
				prevTitle: page.title,
				prevTemplate: page.template,
				prevContentSection: page.content_section
			} )

			setTimeout( () => {
				this.setState( {
					prevTitle: null,
					prevTemplate: null,
					prevContentSection: null
				} )
			}, 1000 )
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		const { slidesCount } = this.props

		if ( ! slidesCount && prevProps.slidesCount ) {
			clearInterval( this.interval )
		}

		if ( slidesCount && ! prevProps.slidesCount || slidesCount != prevProps.slidesCount ) {
			clearInterval( this.interval )

			this.setupSlider()
		}
	}

	setupSlider = () => {
		this.interval = setInterval( this.timer, 3000 )

		setTimeout( () => {
			const slides = document.querySelectorAll( '.js-words span' )
			let maxWidth = 0

			Array.from( slides ).forEach( ( slide, i ) => {
				if ( slide.offsetWidth > maxWidth ) {
					maxWidth = slide.offsetWidth
				}
			} )

			this.setState( {
				width: maxWidth
			} )

			const el = document.querySelector( '.js-words' )

			if ( el ) {
				el.setAttribute( 'style', `width: ${maxWidth}px` )
			}

			this.timer()
		}, 500 )
	}

	timer = () => {
		const { slidesCount, activeSlide } = this.state
		const activeSlideNew = activeSlide == slidesCount ? 1 : activeSlide + 1

		this.setState({
			activeSlide: activeSlideNew
		})

		const elements = document.querySelectorAll( '.js-words span' )

		Array.from( elements ).forEach( ( element, i ) => {
			if ( i == ( activeSlide - 1 ) ) {
				element.classList.add( 'is-active' )
			} else {
				element.classList.remove( 'is-active' )
			}
		})
	}

	togglePageLinks = () => {
		this.setState( {
			pageLinksIsOpen: ! this.state.pageLinksIsOpen
		} )
	}

	handleClickPageLink = () => {
		this.setState( {
			pageLinksIsOpen: false
		} )
	}

	handleImageLoaded = () => {
		this.setState( {
			imageLoaded: true
		} )
	}

	renderLoading() {
		return (
			<div className="page-header page-header-is-loading">
				<div className="-inner">
					<div className="-image"></div>
				</div>
			</div>
		)
	}

	renderPageLinks = () => {
		const { page } = this.props
		const { pageLinksIsOpen } = this.state
		const toggleText = pageLinksIsOpen ? 'Hide menu' : 'Show menu'
		const className = pageLinksIsOpen ? '-page-links is-open' : '-page-links'
		let contentData = ''

		if ( ! page.page_links ) {
			return null
		}

		contentData = JSON.stringify( page.page_links )

		return (
			<div className={ className }>
				<div className="-toggle" onClick={ this.togglePageLinks }>
					<p>{ toggleText }</p>
				</div>

				<div className="-items">
					{ loopArray( page.page_links, ( key, item ) => {
						if ( ! item.post ) {
							return null
						}

						let className = '-item'

						if ( item.post.id == page.id ) {
							className += ' is-active'
						}

						return (
							<Link to={ item.post.url } className={ className } onClick={ this.handleClickPageLink } key={ key }>
								<div className="-inner">
									<div className="-page-link-text">
										<p>{ item.post.title }</p>
									</div>
								</div>
							</Link>
						)
					} ) }
				</div>
			</div>
		)
	}

	renderImage( imageData, isPrevious = false ) {
		const { imageLoaded } = this.state
		let wrapClass = imageLoaded ? '-image is-loaded' : '-image'

		if ( isPrevious ) {
			wrapClass = '-image is-loaded is-previous'
		}

		if ( ! imageData || ! imageData.url ) {
			return (
				<div className={ wrapClass }>
					<img
						className="-full"
						src={ `${siteData.images_url}photos/oivhemfo-kk-andrew-scofield.jpg` }
						alt=""
						onLoad={ this.handleImageLoaded }
					/>
				</div>
			)
		}

		const wrapStyle = {
			// paddingBottom: 100 / page.featured_image.aspect_ratio + '%'
		}

		let imageMarkup, prevImageMarkup
		const srcset = imageData.srcset ? imageData.srcset : undefined

		// Calculate CSS percentages:
		let imagePosition = null

		if ( imageData.focal_point ) {
			const percentageX = ( imageData.focal_point.x / imageData.width ) * 100
			const percentageY = ( imageData.focal_point.y / imageData.height ) * 100
			imagePosition = percentageX.toFixed( 0 ) + '% ' + percentageY.toFixed( 0 ) + '%'
		} else if ( imageData.position ) {
			imagePosition = imageData.position
		}

		const imageStyle = {
			objectPosition: imagePosition
		}

		imageMarkup = (
			<div className={ wrapClass } style={ wrapStyle } key={ imageData.id }>
				<Editable
					id="page_featured_image"
					className="-inner"
				>
					<img
						className="-thumb"
						src={ imageData.thumb }
						alt={ imageData.alt }
						style={ imageStyle }
					/>

					<img
						className="-full"
						alt={ imageData.alt }
						src={ imageData.url }
						srcSet={ srcset }
						sizes="100vw"
						onLoad={ this.handleImageLoaded }
						style={ imageStyle }
					/>
				</Editable>
			</div>
		)

		return imageMarkup
	}

	renderActivityMeta = () => {
		const { page, type } = this.props

		if ( 'activity' != type ) {
			return null
		}

		return (
			<div className="activities-filters">
				<div className="-inner">
					<div className="-activity-meta">
						{ page.pathway &&
							<p>Pathway: { page.pathway }</p>
						}

						{ page.age_group &&
							<p>Age group: { page.age_group }</p>
						}

						{ page.theme &&
							<p>Theme: { page.theme }</p>
						}

						{ page.anticipated_time &&
							<p>Anticipated time: { page.anticipated_time }</p>
						}

						{ page.group_size &&
							<p>Group size: { page.group_size }</p>
						}

						{ page.values &&
							<p>Values: { page.values }</p>
						}
					</div>
				</div>
			</div>
		)
	}

	renderMasterHonour = () => {
		return (
			<div className="-master-note">
				<h4>Doubling Up Rule</h4>
				<p>Some Honours may be included in more than one Master Award. For example, the Shells Honour is part of the Naturalist Master and also the Zoology Master Award.</p>
				<p>The rationale is that a shell is part of nature and it is also an animal. If a Shell Honour has been used to earn a Naturalist Master Award, the same Honour cannot be used to earn a Zoology Master Award.</p>
				<p>This ‘Doubling Up’ rule applies to all Honours in such a situation.</p>
			</div>
		)
	}

	renderContent() {
		const { type, page, overrideImage, overrideText, styleType, isMobile, isLoading } = this.props
		const { prevImage, prevTitle, prevTemplate, prevContentSection } = this.state
		let className = 'page-header'
		let showActivitiesFilters = false
		let showActivityMeta = false

		if ( ! page ) {
			return null
		}

		if ( styleType ) {
			className += `-${styleType}`
		}

		if ( 'activities' == type ) {
			showActivitiesFilters = true
			className += ' with-activities-filters'
		}

		if ( 'activity' == type ) {
			showActivityMeta = true
		}

		const imageData = overrideImage ? overrideImage : page.featured_image
		let titleText = ( page && page.title ) ? page.title.rendered : ''
		let textClass = `-text`
		let titleClass = ''

		if ( prevTitle ) {
			titleText = prevTitle.rendered
			textClass += ' is-previous'
			className += ` -content-section-${prevContentSection}`
		} else {
			if ( page.content_section ) {
				className += ` -content-section-${page.content_section}`
			}
		}

		if ( prevTemplate ) {
			textClass += ` -previous-page-${prevTemplate}`
		} else if ( page.template ) {
			textClass += ` -page-${page.template}`
		}

		if ( titleText.length > 30 ) {
			titleClass += ' is-long'
		}

		const title = (
			<Editable
				id="page_title"
				element="h1"
				className={ titleClass }
				content={ titleText }
			/>
		)

		const titleWrapClass = ( showActivitiesFilters || 'activities-category' == type || 'activity' == type ) ? '-title-alt' : '-title'
		const text = overrideText ? overrideText : (
			<div className={ titleWrapClass } key={ `${page.id}-title` }>
				{ title }
			</div>
		)

		const primaryCatSlug = get( [ 'category', 'primary', 'slug' ] )( page )

		const pageLinks = this.renderPageLinks()

		if ( isMobile && !! pageLinks ) {
			return [
				<div className={ className } key="a">
					<div className="-inner">
						<div className="-image-wrap">
							{ prevImage && this.renderImage( prevImage, true ) }

							{ this.renderImage( imageData ) }
						</div>

						<div className={ textClass }>
							<div className="-inner">
								{ text }
							</div>
						</div>
					</div>
				</div>,

				<div className="mobile-page-links" key="b">
					{ pageLinks }
				</div>
			]
		} else {
			return (
				<div className={ className }>
					<div className="-inner">
						<div className="-image-wrap">
							{ prevImage && this.renderImage( prevImage, true ) }

							{ this.renderImage( imageData ) }
						</div>

						<div className={ textClass }>
							<div className="-inner">
								{ text }

								{ pageLinks }

								{ showActivitiesFilters &&
									<ActivitiesFilters { ...this.props } />
								}

								{ showActivityMeta && this.renderActivityMeta() }

								{ 'master-honours' == primaryCatSlug && this.renderMasterHonour() }

								{ ( ! isLoading && ! prevTitle ) &&
									<React.Fragment>
										{ 'honours' == this.props.type &&
											<section className="-back-to">
												<Link to="/honour-types" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
											</section>
										|| 'master-honours' == this.props.type &&
											<section className="-back-to">
												<Link to="/honour-types" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
											</section>
										|| 'new-honours' == this.props.type &&
											<section className="-back-to">
												<Link to="/honour-types" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
											</section>
										|| 'revised-honours' == this.props.type &&
											<section className="-back-to">
												<Link to="/honour-types" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
											</section>
										|| 'honours-category' == this.props.type &&
											<section className="-back-to">
												<Link to="/honours" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
											</section>
										|| '/new-honour-templates/' == this.props.pathname &&
											<section className="-back-to">
												<Link to="/honour-types" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
											</section>
										|| ( 'honour' == this.props.type && page.category && page.category.primary && page.category.primary.url ) &&
											<section className="-back-to">
												<Link to={ page.category.primary.url } className="button -svg-stroke"><IconBack /><span dangerouslySetInnerHTML={ { __html: page.back_link_text } } /></Link>
											</section>
										}
									</React.Fragment>
								}
							</div>
						</div>
					</div>
				</div>
			)
		}
	}

	render() {
		return this.renderContent()
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const { selected, selectedArchive } = state.page

	let page = false,
		featuredImage,
		hasCorrectPageData

	// if ( ownProps.pageOverride ) {
	// 	page = ownProps.pageOverride
	// } else if ( selectedArchive ) {
	// 	page = selectedArchive
	// } else {
		page = {
			...selected
		}
	// }

	if ( selectedArchive && selectedArchive.title ) {
		page.title = selectedArchive.title
	}

	if ( selectedArchive && selectedArchive.featured_image ) {
		page.featured_image = selectedArchive.featured_image
	}

	// if ( selectedArchive ) {
	// 	featuredImage = selectedArchive.featured_image

	// 	hasCorrectPageData = ( selectedArchive && ownProps.type == selectedArchive.type )
	// } else {
		const slug = get( [ 'match', 'params', 'slug' ] )( ownProps )

		featuredImage = selected.featured_image

		hasCorrectPageData = ( selected && slug == selected.slug )
	// }

	return {
		isLoading: state.page.isLoading,
		isMobile: state.site.isMobile,
		page,
		hasCorrectPageData,
		featuredImage
	}
}

export default connect( mapStateToProps )( PageHeader )



// WEBPACK FOOTER //
// ./components/PageHeader/PageHeader.jsx